function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".st2{fill:#5c6a7c}");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Shape_6_",
  d: "M17.5 14.4l-4.9-6.1-.1-.1c-.3-.3-.8-.3-1.1 0l-.1.1-4.9 6.1c-.2.2-.2.4-.2.7 0 .5.4 1 .9 1h9.7c.3 0 .5-.1.7-.4.3-.4.3-1 0-1.3z",
  fill: "#9ea7bc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M12 6.6c.4 0 .6-.2.6-.6v-.6c0-.3-.3-.5-.6-.5s-.6.2-.6.6V6c0 .3.2.6.6.6zM12.5 8.2V8c0-.4-.2-.6-.5-.6s-.6.2-.6.6v.2c.3-.3.8-.3 1.1 0zM12 4c.3 0 .6-.2.6-.6v-.5c0-.4-.3-.6-.6-.6s-.6.2-.6.6v.6c0 .3.3.5.6.5zM12 20.3c-.3 0-.6.2-.6.6v.3c0 .3.2.6.6.6s.6-.2.6-.6v-.3c0-.4-.3-.6-.6-.6zM11.4 16.1v.2c0 .3.2.6.6.6s.6-.2.6-.6v-.2h-1.2zM12 17.7c-.3 0-.6.2-.6.6v.6c0 .3.2.6.6.6s.6-.2.6-.6v-.6c0-.4-.3-.6-.6-.6z"
});

var SvgIcCenteringHorizontallyAct = function SvgIcCenteringHorizontallyAct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCenteringHorizontallyAct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_centering-horizontally-ACT.d1224af4.svg";
export { ForwardRef as ReactComponent };